<template>
  <layout>

    <div className="content">
      <b-card v-if="$account && $account.partner" v-html="$t('partners.expert_link_text')">
      </b-card>
    </div>
  </layout>
</template>

<script>

export default {
  name: 'Test3',

  components: {},

  data() {
    return {}
  },

  computed: {},

  methods: {},
}
</script>
